// src/globals/utils/customToast.js
import Toastify from "toastify-js";

export const customToast = (message, type = 'success', duration = 3000) => {

    let customColors = {
        error: "linear-gradient(to right, #fc4236, #af2d25)",
        success: "linear-gradient(to right, #64a345, #446f2f)",
    }

    Toastify({
        text: message,
        duration: duration,
        close: true,
        gravity: "top",
        position: "right",
        style: {
            background: type === "error" ? customColors.error : customColors.success,
        },
    }).showToast();
}
